module.exports = __webpack_public_path__ + "img/error-status.64588d38.svg";